// Biometric (Face ID / Touch ID) unlock via WebAuthn platform authenticator
const CRED_KEY = 'pocket_bio_cred';

export const bioSupported = () =>
  typeof window !== 'undefined' && !!window.PublicKeyCredential && !!navigator.credentials;

export const bioEnabled = () => !!localStorage.getItem(CRED_KEY);
export const disableBio = () => localStorage.removeItem(CRED_KEY);

export async function enableBio(user) {
  const challenge = crypto.getRandomValues(new Uint8Array(32));
  const cred = await navigator.credentials.create({
    publicKey: {
      challenge,
      rp: { name: 'Pocket Up' },
      user: {
        id: new TextEncoder().encode(user?.email || 'pocket-user'),
        name: user?.email || 'pocket-user',
        displayName: user?.name || user?.email || 'Pocket User',
      },
      pubKeyCredParams: [{ type: 'public-key', alg: -7 }, { type: 'public-key', alg: -257 }],
      authenticatorSelection: { authenticatorAttachment: 'platform', userVerification: 'required' },
      timeout: 60000,
      attestation: 'none',
    },
  });
  const raw = new Uint8Array(cred.rawId);
  localStorage.setItem(CRED_KEY, btoa(String.fromCharCode(...raw)));
  return true;
}

export async function verifyBio() {
  const b64 = localStorage.getItem(CRED_KEY);
  if (!b64) return false;
  const id = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  const challenge = crypto.getRandomValues(new Uint8Array(32));
  await navigator.credentials.get({
    publicKey: {
      challenge,
      allowCredentials: [{ type: 'public-key', id, transports: ['internal'] }],
      userVerification: 'required',
      timeout: 60000,
    },
  });
  return true;
}
